export const graphQLErrorsList: string[] = [
  'BAD_CREDENTIALS',
  'PERSON_NOT_FOUND_IN_DEAL',
  'PIPEDRIVE_DUN_COMPANY_NOT_FOUND',
  'DEAL_ALREADY_EXISTS_IN_SFDI',
  'ORGANIZATION_NOT_FOUND_IN_DEAL',
  'DUN_ID_NOT_FOUND',
  'DUNS_NOT_PROVIDED',
  'ATRADIUS_LIMIT_NOT_ORDERED',
  'ATRADIUS_BUYER_NOT_FOUND',
  'PROSPECT_COMPANY_COUNTRY_NOT_FOUND',
  'INVALID_APPROVAL_INITIATION',
  'ACTION_KEY_INVALID',
  'DEBTOR_DUPLICATE',
  'DEBTOR_ALREADY_EXISTS',
  'DEAL_IN_STOPLIST',
  'CLIENT_ALREADY_EXISTS',
  'LOGIN_IS_NOT_UNIQUE',
  'DEBTOR_CLIENT_RELATIONSHIP_ALREADY_EXISTS',
  'COLLATERAL_DUPLICATE',
  'DEBTOR_ALREADY_ASSIGNED',
  'AMOUNT_IS_THAN_OPEN_AMOUNT',
  'AMOUNT_IS_THAN_PAYMENT_AMOUNT',
  'BANK_ACCOUNT_NOT_FOUND',
  'BANK_STATEMENT_EXPIRED',
  'BANKS_STATEMENT_FILE_BANKS_MISMATCH',
  'BANKS_STATEMENT_FILE_IBAN_MISMATCH',
  'BANK_STATEMENT_IS_CLOSED',
  'TRANSACTION_IS_CLOSED',
  'NAMESPACE_NOT_FOUND',
  'BANK_STATEMENT_PARSING_ERROR',
  'CORRUPTED_BANK_STATEMENT_FILE',
  'BANK_STATEMENT_NOT_FOUND',
  'RECONCILIATION_IS_STARTED',
  'CONTRACT_NOT_ASSIGNED_TO_DEBTOR',
  'RELATIONSHIP_CANNOT_ADD',
  'RELATIONSHIP_CANNOT_CLOSE',
  'RELATIONSHIP_CANNOT_REJECT',
  'RELATIONSHIP_CANNOT_APPROVE',
  'RELATIONSHIP_CANNOT_UPDATE_QUESTIONNAIRE',
  'RELATIONSHIP_CANNOT_REQUEST_CREDIT_LIMIT',
  'CLIENT_CANNOT_UPDATE_ADDRESS',
  'CLIENT_CANNOT_UPDATE_INVOICE',
  'HAS_NO_RIGHTS_FOR_CURRENT_ACTION',
  'AUTHORITY_COUNTRY_COMBINATION_IS_NOT_UNIQUE',
  'BAD_AUTHORITY_GROUPING',
  'TASK_NOT_FOUND',
  'NO_COC_NUMBER',
  'COMPANY_NOT_FOUND',
  'WISE_FUNDING_ERROR',
  'NO_RATING_FOUND',
  'PAID_VAT_NOTE_CANNOT_BE_CHANGED',
  'SUPPLIER_NOT_MUTABLE_FOR_REVERSE_FACTORING_INVOICES',
  'MAX_INSURER_EXCEEDED',
  'MAX_BND_LIMIT_EXCEEDED',
  'MAX_BND_LIMIT_EXCEEDED_PLN',
  'ACTIONS_NOT_ALLOWED',
  'INVALID_FILE_FORMAT',
]
export const notFoundErrorsList = [
  'BROKER_FEE_NOT_FOUND',
  'INVOICE_NOT_FOUND',
  'DUNS_ORGANIZATION_NOT_FOUND',
  'FULL_RETURN_NOT_FOUND',
  'BROKER_REPORT_NOT_FOUND',
  'PARTNER_NOT_FOUND',
  'DEBTOR_NOT_FOUND',
  'INVOICE_VERIFICATION_NOT_FOUND',
  'DEBTOR_GROUP_NOT_FOUND',
  'FUNDING_LINE_LIMIT_NOT_FOUND',
  'CLIENT_NOT_FOUND',
  'CONTRACT_TYPE_NOT_FOUND',
  'CONTRACT_NOT_FOUND',
  'CREDIT_MANAGEMENT_GROUP_NOT_FOUND',
  'GL_ACCOUNT_NOT_FOUND',
  'SOURCING_AGENT_NOT_FOUND',
  'SUPPLIER_NOT_FOUND',
  'CLIENT_DOCUMENT_NOT_FOUND',
  'CONTACT_NOT_FOUND',
  'REPRESENTATIVE_NOT_FOUND',
  'OUTSTANDING_VERIFICATION_NOT_FOUND',
  'VERIFICATION_RESPONSE_NOT_FOUND',
  'SETTLEMENT_NOT_FOUND',
  'BILLING_SETTLEMENT_NOT_FOUND',
  'CMP_NOT_FOUND',
  'OVERDUE_PLAN_NOT_FOUND',
  'OVERDUE_TASK_NOT_FOUND',
  'TASK_NOT_FOUND',
  'DEBTOR_DOCUMENT_NOT_FOUND',
  'REPORT_NOT_FOUND',
  'INVOICE_RATES_NOT_FOUND',
  'CREDIT_NOTE_NOT_FOUND',
  'NOT_FOUND',
  'PAYOUT_NOTE_NOT_FOUND',
  'LOAN_BOOK_DOCUMENT_NOT_FOUND',
  'SECURITY_MEASURE_NOT_FOUND',
  'LOAN_BOOK_VAT_NOTE_NOT_FOUND',
  'CLARIFICATION_NOT_FOUND',
  'PAYOUT_NOT_FOUND',
  'PURCHASE_NOTE_NOT_FOUND',
  'VAT_NOTE_NOT_FOUND',
  'RECONCILIATION_NOT_FOUND',
  'FAB_USER_NOT_FOUND',
  'USER_NOT_FOUND',
  'ACCOUNT_MANAGER_NOT_FOUND',
]
